import {
    APP_INIT
  } from "../constants/login";
  
  
  export const setApp = (app) => {
    return dispatch => {
      dispatch(
        {
          type: APP_INIT,
          payload: app
        }
      );  
    };
  };